import MComponent from '../Toolkit/Components/Component';
import {withMsal, WithMsalProps} from '@azure/msal-react';
import WithRouterProps from '../Toolkit/WithRouterProps';
import WithRouter from '../Toolkit/WithRouter';
import React, {createRef, ReactElement, RefObject} from 'react';
import {CreateNoticeValidator, NoticeHeader, NoticeDetail, NoticeReply, NoticeDetailReply, NoticeHeaderReply} from '../Api/NoticeTypes';
import * as Yup from 'yup';
import MPage, {MPageProps} from '../Toolkit/Components/Shell/Page';
import MToolbar from '../Toolkit/Components/Controls/Toolbar';
import MButton from '../Toolkit/Components/Controls/Button';
import {MCloseIconName, MNavigateToIconName, MSaveIconName, MSuccessIcon} from '../Toolkit/Icons';
import MSpacer from '../Toolkit/Components/Controls/Spacer';
import EnumContext from '../Context/enum-context';
import MForm, {MFormOutcome} from '../Toolkit/Components/Controls/Form';
import {FieldProps, FormikHelpers} from 'formik';
import {MNullable, toErrorMessage} from '../Toolkit/Utils';
import FormSection from '../Toolkit/Components/Controls/FormSection';
import MFormFieldControl from '../Toolkit/Components/Controls/FormFieldControl';
import MTextBox from '../Toolkit/Components/Controls/TextBox';
import MNumericBox from './Components/NumericBox';
import MDropDownMulti from './Components/DropDownMulti';
import MDropDown from '../Toolkit/Components/Controls/DropDown';
import TextArea from './Components/TextArea';
import MCalendar from '../Toolkit/Components/Controls/Calendar';
import {MDropDownItem} from '../Toolkit/Components/Controls/DropDownOption';
import NSwagAdapter from '../Toolkit/Api/NSwagAdapter';
import {NoticeClient, NoticeCreateDto} from '../Api/NoticeClients';
import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';
import SafeDigAccessTokenProvider from '../Api/SafeDigAccessTokenProvider';
import MAlertDialog from '../Toolkit/Components/Controls/AlertDialog';
import AlertDialog from '../Toolkit/Components/Controls/AlertDialog';
import {Divider} from 'primereact/divider';
import {ProjectReply, SafeDigReply} from '../Api/SafeDigTypes';
import {SafeDigClient} from '../Api/SafeDigsClients';

class NewNotice {
    public odinId: string = ''
    public safeDigId: number = -1;
    public parentId: number = -1;
    public requestedDate: MNullable<Date> = null;
    public address1: string = ''
    public address2: string = '';
    public address3: string = '';
    public county: string = '';
    public easting: number = 0;
    public northing: number = 0;
    public easting2?: number = undefined;
    public northing2?: number = undefined;
    public worksLocation: number[] = [];
    public workDescription: string = '';
    public requestor: string = '';
    public startDate: MNullable<Date> = null;
    public endDate: MNullable<Date> = null;
    public tmType: number[] = [];
    public fwClosureType: number = 0;
    public trafficSensitiveHours: number = 0;
    public hoursOfWork: string = '';
    public excavationRequired: number = 0;
    public permitType: number = -1;
    public l2id?: string = undefined;
    public project: number = -1;
    public subResource: number = -1;
};

type RouteParams = {
    sourceType: number;
    sourceId: number;
    param1: number;
};

type Props =  WithMsalProps & WithRouterProps<RouteParams> & {};

type State = {
    page: MPageProps;
    pageTitle: string;
    pageSubTitle: string;
    form: {
        id: string;
        isSubmitting: boolean;
        notice: NewNotice;
        validationSchema: any;
    };
    projectList: MDropDownItem<number>[];
};

class CreateNoticePage extends MComponent<Props, State> {
    static contextType = EnumContext;
    context!: React.ContextType<typeof EnumContext>

    private m_newNotice: MNullable<NoticeDetail> | undefined;
    private readonly m_pageRef: RefObject<MPage>;
    private readonly m_dialogRef: RefObject<MAlertDialog>;
    private readonly m_noticeClient: NSwagAdapter<NoticeClient>;
    private readonly m_safedigClient: NSwagAdapter<SafeDigClient>;

    public constructor(props: Props) {
        super(props);

        this.bindMethods();

        this.m_pageRef = createRef<MPage>();
        this.m_dialogRef = createRef<MAlertDialog>();
        this.m_noticeClient = new NSwagAdapter<NoticeClient>(new NoticeClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));
        this.m_safedigClient = new NSwagAdapter<SafeDigClient>(new SafeDigClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_SAFEDIGS_API_KEY!,
                new SafeDigAccessTokenProvider(this.props.msalContext))));

        this.initializeState();

    }

    private bindMethods(): void {
        this.close_Click = this.close_Click.bind(this);
        this.form_onBeforeSubmit = this.form_onBeforeSubmit.bind(this);
        this.form_onSubmit = this.form_onSubmit.bind(this);
        this.form_onAfterSubmit = this.form_onAfterSubmit.bind(this);
        this.form_onError = this.form_onError.bind(this);
        this.page_onLoadData = this.page_onLoadData.bind(this);
        this.isFormDisabled = this.isFormDisabled.bind(this);
        this.isHeaderDisabled = this.isHeaderDisabled.bind(this);
        this.showNoticeCreatedDialog = this.showNoticeCreatedDialog.bind(this);
        this.setInitialData = this.setInitialData.bind(this);
    }

    private initializeState(): void {
        const page: MPageProps = {locked: false};

        const data: NewNotice = {
            odinId: '',
            safeDigId: -1,
            parentId: -1,
            requestedDate: new Date(),
            address1: '',
            address2: '',
            address3: '',
            county: '',
            northing: 0,
            easting: 0,
            northing2: undefined,
            easting2: undefined,
            worksLocation: [],
            workDescription: '',
            requestor: '',
            startDate: null,
            endDate: null,
            tmType: [],
            fwClosureType: -1,
            trafficSensitiveHours: -1,
            hoursOfWork: '',
            excavationRequired: -1,
            permitType: -1,
            l2id: undefined,
            project: -1,
            subResource: -1
        };

        const validationSchema: any = Yup.object().shape({
            odinId: CreateNoticeValidator.odinId,
            requestedDate: CreateNoticeValidator.requestedDate,
            address1: CreateNoticeValidator.address1,
            address2: CreateNoticeValidator.address2,
            address3: CreateNoticeValidator.address3,
            //county: CreateNoticeValidator.county,
            northing: CreateNoticeValidator.northing,
            easting: CreateNoticeValidator.easting,
            northing2: CreateNoticeValidator.northing2,
            easting2: CreateNoticeValidator.easting2,
            worksLocation: CreateNoticeValidator.worksLocations,
            workDescription: CreateNoticeValidator.workDescription,
            requestor: CreateNoticeValidator.requestor,
            startDate: CreateNoticeValidator.startDate,
            endDate: CreateNoticeValidator.endDate,
            tmType: CreateNoticeValidator.tmType,
            trafficSensitiveHours: CreateNoticeValidator.trafficSensitiveHours,
            hoursOfWork: CreateNoticeValidator.hoursOfWork,
            excavationRequired: CreateNoticeValidator.excavationRequired,
            fwClosureType: CreateNoticeValidator.fwClosureType,
            permitType: CreateNoticeValidator.permitType,
            l2id: CreateNoticeValidator.l2id,
            project: CreateNoticeValidator.project
        });

        this.state = {
            page: page,
            pageTitle: 'Create New Notice',
            pageSubTitle: '',
            form: {
                isSubmitting: false,
                id: 'createNoticeForm',
                notice: data,
                validationSchema: validationSchema
            },
            projectList: []
        };
    }

    public componentDidMount(): void {
        //Use the currently logged in user as the default requestor.
        const userName = this.props.msalContext.accounts[0].name;
        this.safeSetState((draft) => {
            draft.form.notice.requestor = userName!;
        });
    }

    private isFormDisabled(): boolean {
        return this.state.form.isSubmitting;
    }

    private isHeaderDisabled(): boolean {
        return Number(this.props?.match?.params?.sourceType ?? 1) === 2;
    }

    /** */
    private async close_Click(): Promise<void> {
        this.props.history.goBack();
    }

    private async page_onLoadData(): Promise<void> {
        const projectResult = await this.m_safedigClient.callWithReply(
            ProjectReply, (client) => client.getProjects());
        projectResult.throwIfFailed();

        const listRows = projectResult.reply!.data.map(project => ({
            value: project.id,
            label: project.name
        }));

        this.safeSetState((draft) => {
            draft.projectList = listRows;
        });

        await this.setInitialData();
    }

    private async setInitialData(): Promise<void> {
        if(Number(this.props.match.params.sourceType) === 0) {   //Safe Dig
            const safeDigResult = await this.m_safedigClient.callWithReply(
                SafeDigReply, (client) => client.get(Number(this.props.match.params.sourceId)));
            safeDigResult.throwIfFailed();

            this.safeSetState((draft) => {
                draft.form.notice.safeDigId = safeDigResult.reply!.data!.safeDigsId;
                draft.form.notice.odinId = safeDigResult.reply!.data!.estimate;
                draft.form.notice.project = safeDigResult.reply!.data!.project;
                draft.form.notice.workDescription = safeDigResult.reply!.data!.workDescription;
                draft.form.notice.address1 = safeDigResult.reply!.data!.address1;
                draft.form.notice.address2 = safeDigResult.reply!.data!.address2;
                draft.form.notice.address3 = safeDigResult.reply!.data!.address3;
                draft.form.notice.easting = safeDigResult.reply!.data!.easting;
                draft.form.notice.northing = safeDigResult.reply!.data!.northing;
                draft.form.notice.easting2 = safeDigResult.reply!.data!.easting2;
                draft.form.notice.northing2 = safeDigResult.reply!.data!.northing2;
            });
        } else if(Number(this.props.match.params.sourceType) === 1) {    //Sub Notice
            const noticeResult = await this.m_noticeClient.callWithReply(
                NoticeReply, (client) => client.notice(Number(this.props.match.params.sourceId)));
            noticeResult.throwIfFailed();

            const subCountTag = (Number(this.props.match.params.param1) + 1).toString().padStart(3, '0');

            this.safeSetState((draft) => {
                draft.form.notice.safeDigId = noticeResult.reply!.header!.safeDigId;
                draft.form.notice.parentId = noticeResult.reply!.header!.id;
                draft.form.notice.odinId = `${noticeResult.reply!.header!.odinId}-${subCountTag}`;
                draft.form.notice.permitType = noticeResult.reply!.detail!.permitType;
                draft.form.notice.project = noticeResult.reply!.header!.project;
                draft.form.notice.l2id = noticeResult.reply!.header!.l2Id;
                draft.form.notice.worksLocation = noticeResult.reply!.detail!.worksLocations;
                draft.form.notice.tmType = noticeResult.reply!.detail!.tmType;
                draft.form.notice.fwClosureType = noticeResult.reply!.detail!.fwClosureType;
                draft.form.notice.trafficSensitiveHours = noticeResult.reply!.detail!.trafficSensitiveHours;
                draft.form.notice.hoursOfWork = noticeResult.reply!.detail!.hoursOfWork;
                draft.form.notice.excavationRequired = noticeResult.reply!.detail!.excavationRequired === true ? 1 : 0;
                draft.form.notice.workDescription = noticeResult.reply!.detail!.workDescription;
                draft.form.notice.address1 = noticeResult.reply!.detail!.address1;
                draft.form.notice.address2 = noticeResult.reply!.detail!.address2;
                draft.form.notice.address3 = noticeResult.reply!.detail!.address3;
                draft.form.notice.easting = noticeResult.reply!.detail!.easting;
                draft.form.notice.northing = noticeResult.reply!.detail!.northing;
                draft.form.notice.easting2 = noticeResult.reply!.detail!.easting2;
                draft.form.notice.northing2 = noticeResult.reply!.detail!.northing2;
            });
        } else if(Number(this.props.match.params.sourceType) === 2) {    //Notice Detail
            const noticeResult = await this.m_noticeClient.callWithReply(
                NoticeHeaderReply, (client) => client.noticeHeader(Number(this.props.match.params.sourceId)));
            noticeResult.throwIfFailed();

            this.safeSetState((draft) => {
                draft.form.notice.safeDigId = noticeResult.reply!.noticeHeader!.safeDigId;
                draft.form.notice.parentId = Number(this.props.match.params.sourceId);
                draft.form.notice.odinId = noticeResult.reply!.noticeHeader!.odinId;
                draft.form.notice.project = noticeResult.reply!.noticeHeader!.project;
                draft.form.notice.l2id = noticeResult.reply!.noticeHeader!.l2Id;
            });
        }
    }

    private form_onBeforeSubmit(fieldValues: NewNotice, formikHelpers: FormikHelpers<NewNotice>): boolean {
        this.safeSetState(draft => draft.form.isSubmitting = true);
        return false;
    }

    private async form_onSubmit(fieldValues: NewNotice, formikHelpers: FormikHelpers<NewNotice>): Promise<void> {
        const newNotice = new NoticeCreateDto({
            odinId: fieldValues.odinId,
            safeDigId: fieldValues.safeDigId,
            parentId: fieldValues.parentId,
            address1: fieldValues.address1,
            address2: fieldValues.address2,
            address3: fieldValues.address3,
            county: fieldValues.county,
            easting: fieldValues.easting,
            northing: fieldValues.northing,
            easting2: fieldValues.easting2 === undefined || fieldValues.easting2 === null ? 0 : fieldValues.easting2,
            northing2: fieldValues.northing2 === undefined || fieldValues.northing2 === null ? 0 : fieldValues.northing2,
            worksLocations: fieldValues.worksLocation,
            workDescription: fieldValues.workDescription,
            requestor: fieldValues.requestor,
            startDate: fieldValues.startDate,
            endDate: fieldValues.endDate,
            tmType: fieldValues.tmType,
            fwClosureType: fieldValues.fwClosureType,
            trafficSensitiveHours: fieldValues.trafficSensitiveHours,
            hoursOfWork: fieldValues.hoursOfWork,
            excavationRequired: fieldValues.excavationRequired === 0 ? false : true,
            permitType: fieldValues.permitType,
            l2id: fieldValues.l2id,
            project: fieldValues.project,
            subResource: fieldValues.subResource
        });

        const result = await this.m_noticeClient.callWithReply(NoticeDetailReply, (client => client.create(newNotice)));

        result.throwIfFailed()

        this.m_newNotice = result.reply!.notice;
    }

    private form_onAfterSubmit(outcome: MFormOutcome, fieldValues: NewNotice, formikHelpers: FormikHelpers<NewNotice>, exception: any | undefined): void {
        if(outcome === 'success') {
            this.showNoticeCreatedDialog();
            return;
        }

        this.safeSetState(draft => draft.form.isSubmitting = false);
    }

    private form_onError(exception: any): boolean
    {
        const handled = false;
        this.m_pageRef.current!.messageBar.error(toErrorMessage(exception));
        return handled;
    }

    private showNoticeCreatedDialog(): void {
        this.m_dialogRef.current!.show(
            'Create Notice',
            `A new notice request has been created with ID ${this.m_newNotice?.id}.`,
            MSuccessIcon,
            <MButton label="Open new notice"
                     color="success"
                     icon={MNavigateToIconName}
                     disabled={false}
                     onClick={() => this.props.history.replace(`/notices/${this.m_newNotice?.headerId}`)}/>);
    }

    private getToolbarTemplate(): ReactElement<MToolbar> {
        return (
            <MToolbar>
                <MButton label="Save"
                         formId={this.state.form.id}
                         type="submit"
                         color="success"
                         icon={MSaveIconName}
                         iconOnly={false}
                         isBusy={this.isFormDisabled}
                         disabled={this.isFormDisabled}/>
                <MSpacer/>
                <MButton label="Close"
                         icon={MCloseIconName}
                         disabled={this.isFormDisabled}
                         onClick={this.close_Click}/>
            </MToolbar>
        );

    }

    public render(): ReactElement {

        const yesNoList: MDropDownItem<number>[] = [{label: '-', value: -1},{label: 'No', value: 0},{label: 'Yes', value: 1}];

        return (
          <MPage title={this.state.pageTitle}
                 subtitle={this.state.pageSubTitle}
                 locked={this.state.page.locked}
                 width={8}
                 toolbar={this.getToolbarTemplate()}
                 onLoadData={this.page_onLoadData}
                 ref={this.m_pageRef}>

              <AlertDialog ref={this.m_dialogRef}/>

              <MForm formId={this.state.form.id}
                     initialValues={this.state.form.notice}
                     validationSchema={this.state.form.validationSchema}
                     onBeforeSubmit={this.form_onBeforeSubmit}
                     onSubmit={this.form_onSubmit}
                     onAfterSubmit={this.form_onAfterSubmit}
                     onError={this.form_onError}>

                  <div className="formgrid grid">
                      <div className="col-12">

                          <FormSection title="General">
                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="ID"
                                                     fieldName="odinId">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={NoticeHeader.OdinIdMaxLength}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isFormDisabled || this.isHeaderDisabled}
                                                        className={fieldClasses}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Permit Type'}
                                                     fieldName={'permitType'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                 disabled={false}
                                                                 fieldProps={fieldProps}
                                                                 items={this.context?.enums === null ? [] : this.context?.enums.permitTypes.map((enumvalue) => {
                                                                     return {label: enumvalue.name, value: enumvalue.id};
                                                                 })}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Project'}
                                                     fieldName={'project'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                 disabled={false || this.isHeaderDisabled}
                                                                 fieldProps={fieldProps}
                                                                 items={this.state.projectList}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="L2 ID"
                                                     fieldName="l2id">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={NoticeHeader.L2IdMaxLength}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isFormDisabled || this.isHeaderDisabled}
                                                        className={fieldClasses}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Date Requested"
                                                     fieldName="requestedDate">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MCalendar id={fieldProps.field.name}
                                                         fieldProps={fieldProps}
                                                         disabled={true}
                                                         className={fieldClasses}
                                                         initialValue={fieldProps.field.value}
                                              />
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Requested By"
                                                     fieldName="requestor">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={NoticeDetail.RequestorMaxLength}
                                                        readonly={false}
                                                        fieldProps={fieldProps}
                                                        disabled={true}
                                                        className={fieldClasses}/>
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Works Locations"
                                                     fieldName="worksLocation">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MDropDownMulti<number> id={fieldProps.field.name}
                                                                      disabled={this.isFormDisabled}
                                                                      fieldProps={fieldProps}
                                                                      items={this.context?.enums === null ? [] : this.context?.enums.worksLocationTypes.map((enumvalue) => {
                                                                          return {label: enumvalue.name, value: enumvalue.id};
                                                                      })}
                                                                      initialValue={[]}
                                                                      maxSelectedLabels={5}
                                              />
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Proposed Start Date"
                                                     fieldName="startDate">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MCalendar id={fieldProps.field.name}
                                                         fieldProps={fieldProps}
                                                         disabled={this.isFormDisabled}
                                                         className={fieldClasses}/>
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Proposed End Date"
                                                     fieldName="endDate">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MCalendar id={fieldProps.field.name}
                                                         fieldProps={fieldProps}
                                                         disabled={this.isFormDisabled}
                                                         className={fieldClasses}/>
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="TM Types"
                                                     fieldName="tmType">

                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {

                                          return (
                                              <MDropDownMulti<number> id={fieldProps.field.name}
                                                                      disabled={this.isFormDisabled}
                                                                      fieldProps={fieldProps}
                                                                      items={this.context?.enums === null ? [] : this.context?.enums.tmTypes.map((enumvalue) => {
                                                                          return {label: enumvalue.name, value: enumvalue.id};
                                                                      })}
                                                                      initialValue={[]}
                                                                      maxSelectedLabels={13}
                                              />
                                          );

                                      }}

                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'FW Closure'}
                                                     fieldName={'fwClosureType'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                 disabled={false}
                                                                 fieldProps={fieldProps}
                                                                 items={this.context?.enums === null ? [] : this.context?.enums.fwClosures.map((enumvalue) => {
                                                                     return {label: enumvalue.name, value: enumvalue.id};
                                                                 })}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Traffic Sensitive Hours'}
                                                     fieldName={'trafficSensitiveHours'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                  disabled={this.isFormDisabled}
                                                                  fieldProps={fieldProps}
                                                                  items={this.context?.enums === null ? [] : this.context?.enums.sensitiveHours.map((enumvalue) => {
                                                                      return {label: enumvalue.name, value: enumvalue.id};
                                                                  })}
                                                                  initialValue={-1}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Hours of Work"
                                                     fieldName="hoursOfWork">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={NoticeDetail.HoursOfWorkMaxLength}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isFormDisabled}
                                                        className={fieldClasses}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label={'Excavation Required'}
                                                     fieldName={'excavationRequired'}>
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MDropDown<number> id={fieldProps.field.name}
                                                                  disabled={this.isFormDisabled}
                                                                  fieldProps={fieldProps}
                                                                  items={yesNoList}
                                                                  initialValue={-1}
                                              />
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-12">
                                  <MFormFieldControl label="Work Description"
                                                     fieldName="workDescription">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <TextArea id={fieldProps.field.name}
                                                        maxLength={500}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isFormDisabled}
                                                        className={fieldClasses}
                                                        rows={5}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                          </FormSection>

                          <Divider/>

                          <FormSection title="Location">
                              <div className="col-12 md:col-6">
                                  <MFormFieldControl label="Start location - Eastings"
                                                     fieldName="easting">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MNumericBox id={fieldProps.field.name}
                                                           maxLength={8}
                                                           fieldProps={fieldProps}
                                                           disabled={this.isFormDisabled}
                                                           className={fieldClasses}
                                                           decimalPlaces={0}
                                                           useGrouping={false}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-6">
                                  <MFormFieldControl label="Start location - Northings"
                                                     fieldName="northing">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MNumericBox id={fieldProps.field.name}
                                                           maxLength={8}
                                                           fieldProps={fieldProps}
                                                           disabled={this.isFormDisabled}
                                                           className={fieldClasses}
                                                           decimalPlaces={0}
                                                           useGrouping={false}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-6">
                                  <MFormFieldControl label="End location - Eastings"
                                                     fieldName="easting2">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MNumericBox id={fieldProps.field.name}
                                                           maxLength={8}
                                                           fieldProps={fieldProps}
                                                           disabled={this.isFormDisabled}
                                                           className={fieldClasses}
                                                           decimalPlaces={0}
                                                           useGrouping={false}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-6">
                                  <MFormFieldControl label="End location - Northings"
                                                     fieldName="northing2">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MNumericBox id={fieldProps.field.name}
                                                           maxLength={8}
                                                           fieldProps={fieldProps}
                                                           disabled={this.isFormDisabled}
                                                           className={fieldClasses}
                                                           decimalPlaces={0}
                                                           useGrouping={false}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>
                          </FormSection>

                          <Divider/>

                          <FormSection title="Address">
                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Address1"
                                                     fieldName="address1">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={50}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isFormDisabled}
                                                        className={fieldClasses}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Address2"
                                                     fieldName="address2">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={50}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isFormDisabled}
                                                        className={fieldClasses}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>

                              <div className="col-12 md:col-4">
                                  <MFormFieldControl label="Address3"
                                                     fieldName="address3">
                                      {(fieldProps: FieldProps, fieldClasses: string | undefined) => {
                                          return (
                                              <MTextBox id={fieldProps.field.name}
                                                        maxLength={50}
                                                        fieldProps={fieldProps}
                                                        disabled={this.isFormDisabled}
                                                        className={fieldClasses}/>
                                          );
                                      }}
                                  </MFormFieldControl>
                              </div>
                          </FormSection>

                      </div>
                  </div>
              </MForm>

          </MPage>
        );
    }
}

export default withMsal(WithRouter(CreateNoticePage));